jQuery(function() {
  jQuery(".matchheight").matchHeight({
    byRow: true,
    property: "height",
    target: null,
    remove: false
  });

  jQuery(".matchheight-all").matchHeight({
    byRow: false,
    property: "height",
    target: null,
    remove: false
  });

  jQuery(".aptf-single-tweet-wrapper").matchHeight({
    byRow: false,
    property: "height",
    target: null,
    remove: false
  });
});
